// extracted by mini-css-extract-plugin
export default {"root":"tV5W1WyDjYFKtKQbhUDc","wrap":"D_GjEYIVVbrGA0HTNNyQ","query":"om080awtaQYbXyzARMFX"};